import {
    Source,
    SourceType
} from 'one-model-local';

import {
    formatPhoneNumber
} from '../../subject/src/transform';

import { format } from 'one-util-date';

// ADPAC-317
//TODO: Need to write common method in utils
export const sortFunction = (a: Source, b: Source) => {
    const nameA = a.firstname?.toLowerCase();
    const nameB = b.firstname?.toLowerCase();
    return nameA > nameB ? 1 : -1;
}

/**
 *
 * @param response constains the response of caller details fetched from db
 */

export const TransformCaller = (response: any, context: any) => {
    const { settings } = context;
    const { uisettings: { dateformat } } = settings
    let sourcedata: Source[] = [];
    let sourceresult: any = {
        sourcedata: sourcedata,
        error: undefined

    }
    // TODO:verify backend team check for errors
    if (response && (response.status >= 400 || response.type == "error")) {
        sourceresult.error = response;
    }
    if (response && response.length > 0) {
        response.map((ele: any) => {
            let source: Source = {
                id: undefined,
                mrn: undefined,
                dob: undefined,
                gender: undefined,
                contact: undefined,
                contact_formatted: undefined,
                address: undefined,
                lastname: undefined,
                firstname: undefined,
                middlename: undefined,
                email: undefined,

            };

            source.id = ele.id;
            source.initials = ele.name?.charAt(0);
            source.firstname = ele.name;
            source.contact = ele.phone_ani;
            const formattednumber = formatPhoneNumber(ele.phone_ani);
            source.contact_formatted = formattednumber === "" ? ele.phone_ani : formattednumber;
            source.typename = ele.typename;
            source.address = ele.address;
            source.subtypename = ele.subtypename;
            source.dob = ele.dob ? format(ele.dob, dateformat) : "";
            source.email = ele.email;
            //check for first name and last name for initial

            let name = (ele.name)?.split(" ");
            if (name?.length > 1) {
                let inital = name[0].charAt(0) + name[1].charAt(0);
                source.initials = inital;
            }

            sourcedata.push(source);
        });
    }
    // ADPAC-317
    sourcedata.sort(sortFunction);
    sourceresult.sourcedata = sourcedata;
    return sourceresult;
}


/**
 *
 * @param response constains the response of caller details fetched from db
 */

export const TransformSelectedPatientToCaller = (response: any, context: any, sourceTypeSelected: SourceType) => {

    let id: string = '0';
    if (response && response.length > 0) {

        for (let i = 0; i < response.length; i++) {
            if (response[i]?.typename === sourceTypeSelected?.label) {
                id = response[i]?.id;
                break;
            }
        }
    }
    return id;

}